module.exports = __webpack_public_path__ + "media/images/icons/icon_account-50fc3f4c28ed16248723c539c1c69c83.svg";